import { useEffect } from 'react';
import { toast } from 'sonner';
const STORAGE_KEY = 'pendingToast';
export interface DeferredToastData {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

/** Queue a toast to display after a hard page redirect. */
export function queueDeferredToast(data: DeferredToastData) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

/** Mount once (e.g. in App.tsx) to display and clear any queued toast. */
export function useDeferredToast() {
  useEffect(() => {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    sessionStorage.removeItem(STORAGE_KEY);
    try {
      const data: DeferredToastData = JSON.parse(raw);
      // Small delay so the toast renders after the page is painted
      setTimeout(() => {
        const fn = data.variant === 'destructive' ? toast.error : toast.success;
        fn(data.title, { description: data.description });
      }, 300);
    } catch {
      // ignore corrupt data
    }
  }, []);
}